import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dialog, FontIcon } from 'react-toolbox';
import UserNote from 'components/UserNote';
import S from 'appointment.scss';

class AppointmentNote extends Component {
  state = {
    active: false,
  }

  toggleActive = () => this.setState({ active: !this.state.active });

  render() {
    const { active } = this.state;
    const { note, customer } = this.props;
    return (
      <span>
        <FontIcon className={S.noteIcon} value="note" onClick={this.toggleActive} />
        {active && <Dialog title={`${customer} Appointment Notes`} active={active} onEscKeyDown={this.toggleActive} onOverlayClick={this.toggleActive}>
          <FontIcon value="close" className={S.closeIcon} onClick={this.toggleActive} />
          <UserNote>{note}</UserNote>
        </Dialog>}
      </span>
    );
  }
}

AppointmentNote.propTypes = {
  note: PropTypes.string.isRequired,
  customer: PropTypes.string.isRequired,
};

export default AppointmentNote;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/appointmentNote.jsx